/* global axios */
import ApiClient from './ApiClient';

class WahaSessionsAPI extends ApiClient {
  constructor() {
    super('waha_sessions', { accountScoped: true });
  }

  start(sessionId) {
    return axios.post(`${this.url}/${sessionId}/start`);
  }

  stop(sessionId) {
    return axios.post(`${this.url}/${sessionId}/stop`);
  }

  restart(sessionId) {
    return axios.post(`${this.url}/${sessionId}/restart`);
  }

  logout(sessionId) {
    return axios.post(`${this.url}/${sessionId}/logout`);
  }

  getQrCode(sessionId, format = 'base64') {
    return axios.get(`${this.url}/${sessionId}/qr_code`, {
      params: { format },
    });
  }

  getStatus(sessionId) {
    return axios.get(`${this.url}/${sessionId}/status`);
  }

  updateConfig(sessionId, config) {
    return axios.patch(`${this.url}/${sessionId}/update_config`, {
      waha_session: { config },
    });
  }

  sync() {
    return axios.post(`${this.url}/sync`);
  }
}

export default new WahaSessionsAPI();
